var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8048_136444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.0526,
    height: 15.0526,
    transform: "matrix(1 1.19249e-08 2.38498e-08 -1 0.472656 15.5293)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8048_136444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.07985L2.95291 4.3346C2.73916 4.11153 2.46712 4 2.13677 4C1.80643 4 1.53438 4.11153 1.32063 4.3346C1.10688 4.55767 1 4.84157 1 5.18631C1 5.53105 1.10688 5.81496 1.32063 6.03802L6.68386 11.635C6.91704 11.8783 7.18909 12 7.5 12C7.81091 12 8.08296 11.8783 8.31614 11.635L13.6794 6.03802C13.8931 5.81496 14 5.53105 14 5.18631C14 4.84157 13.8931 4.55767 13.6794 4.3346C13.4656 4.11153 13.1936 4 12.8632 4C12.5329 4 12.2608 4.11153 12.0471 4.3346L7.5 9.07985Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow_down_white.03d51de06d7ec0ee55648e69ff9b9d8c.svg";
export { ForwardRef as ReactComponent };